
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import TooltipLabel from "@/components/general/TooltipLabel.vue";
import ProfitabilityChart from "./ProfitabilityChart.vue";
import BalanceInUseChart from "./BalanceInUseChart.vue";
import TotalBotsStats from "@/models/bots/TotalBotStats";

// Styles
import "@/assets/css/vuetify/chips.css";

@Component({
  components: {
    TooltipLabel,
    ProfitabilityChart,
    BalanceInUseChart,
  },
})
export default class AllBotsChartWrapper extends Vue {
  // 🚩 Flag for whether the charts should show a loading indicator
  @Prop()
  public isLoading!: boolean;

  // 📃 Possible components to show in the chart wrapper
  private POSSIBLE_COMPONENTS = {
    NO_BOTS_PLACEHOLDER: 0,
    NO_TRADES_PLACEHOLDER: 1,
    DO_NOT_MISS_OPPORTUNITY_PLACEHOLDER: 2,
    CHARTS: 3,
    LOADING: 4,
  };

  // 📃 Possible charts to show
  private VisibleChart = {
    BalanceInUse: 1,
    Profitability: 2,
  };

  // 📦 The chart that should be shown
  private selectedVisibleChart: number = 0;

  // 📃 Possible time filters for the chart
  private chartFilters = {
    "1D": 1,
    "7D": 7,
    "30D": 30,
    "90D": 90,
    "Since Start": -1,
  };

  // 📦 The selected portfolio chart filter
  private selectedFilter: string = "";

  // 📦 The selected portfolio chart filter in days
  private selectedFilterInDays: number = 1;

  // 📦 The initial balance for the selected time period
  private initialBalanceForPeriod: number | null = null;

  // 📦 The stats of all bots combined
  private get totalBotsStats(): TotalBotsStats {
    return this.$store.state.bots.totalBotsStats;
  }

  // 📦 The total number of bots created for the account
  private get totalBots(): number {
    return this.$store.getters.totalBots;
  }

  // 📦 The total number of active bots created for the account
  private get totalActiveBots(): number {
    return this.$store.getters.totalActiveBots;
  }

  // 📦 The total number of trades 
  private get totalTrades(): number {
    return this.totalBotsStats.totalTrades;
  }

  // 📦 The currently visible component in the chart wrapper
  private get currentlyVisibleComponent(): number {
    return this.isLoading
      ? this.POSSIBLE_COMPONENTS.LOADING
      : this.POSSIBLE_COMPONENTS.CHARTS;

    // TODO 31/01/2023: Investigate why this getter stuck
    if (this.isLoading) {
      return this.POSSIBLE_COMPONENTS.LOADING;
    }

    if (this.totalBots > 0 && this.totalTrades > 0) {
      return this.POSSIBLE_COMPONENTS.CHARTS;
    }

    if (this.totalBots == 0) {
      return this.POSSIBLE_COMPONENTS.NO_BOTS_PLACEHOLDER;
    }

    if (this.totalActiveBots > 0 && this.totalTrades == 0) {
      return this.POSSIBLE_COMPONENTS.NO_TRADES_PLACEHOLDER;
    }

    if (
      this.totalActiveBots == 0 &&
      this.totalBots > 0 &&
      this.totalTrades == 0
    ) {
      return this.POSSIBLE_COMPONENTS.DO_NOT_MISS_OPPORTUNITY_PLACEHOLDER;
    }

    return this.POSSIBLE_COMPONENTS.CHARTS;
  }

  /**
   * 👂 Listener for changes in the selected period's ROI
   */
  private onInitialBalanceForPeriodChanged(balance: number) {
    this.initialBalanceForPeriod = balance;
  }
}
